import {
  Box,
  IconExpandLess,
  IconExpandMore,
  Skeleton,
  useMediaQuery,
  UserAvatar,
} from '@capitalise/ui-design-system';
import { ColorKey } from '@capitalise/ui-design-system/dist/shared/colors';

interface HeaderMenuProps {
  label: string;
  noLabel: boolean;
  color: ColorKey;
  size: 'xsmall' | 'small';
  open: boolean;
}

const HeaderMenu = ({ label, noLabel, color, size, open }: HeaderMenuProps) => {
  const { isMobile } = useMediaQuery();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      maxWidth="195px"
      gap="4xsmall"
    >
      <Box display="flex" alignItems="center" gap="4xsmall">
        <Box height="small">
          {label && <UserAvatar name={label} color={color} size={size} />}
          {!label && <Skeleton width="small" height="small" borderRadius="50%" />}
        </Box>
        {!isMobile && !noLabel && (
          <Box flex="1">
            {label && (
              <Box
                maxHeight="40px"
                typography="body-14"
                textOverflow="ellipsis"
                overflow="hidden"
                whiteSpace="nowrap"
              >
                {label}
              </Box>
            )}
            {!label && <Skeleton width="87px" />}
          </Box>
        )}
      </Box>
      {!isMobile && (
        <Box display="flex" justifySelf="flex-end">
          {open ? <IconExpandLess /> : <IconExpandMore />}
        </Box>
      )}
    </Box>
  );
};

export default HeaderMenu;
